import { gql } from '@common/hooks';

export type BillingCardEmploymentTypeRatesType = {
  id?: string;
  travelerRate?: {
    id?: string;
    dayBillingRate: number;
    eveningBillingRate: number;
    nightBillingRate: number;
    variableBillingRate: number;
  } | null;
  localRate?: {
    id?: string;
    dayBillingRate: number;
    eveningBillingRate: number;
    nightBillingRate: number;
    variableBillingRate: number;
  } | null;
  directSourcingRate?: {
    id?: string;
    dayBillingRate: number;
    eveningBillingRate: number;
    nightBillingRate: number;
    variableBillingRate: number;
  } | null;
};

export const BillingCardFragment = gql`
  fragment BillingCardFragment on BillingCard {
    id
    name
    travelerRate {
      id
      dayBillingRate
      eveningBillingRate
      nightBillingRate
      variableBillingRate
    }
    localRate {
      id
      dayBillingRate
      eveningBillingRate
      nightBillingRate
      variableBillingRate
    }
    directSourcingRate {
      id
      dayBillingRate
      eveningBillingRate
      nightBillingRate
      variableBillingRate
    }
  }
`;
